import { render, staticRenderFns } from "./FactureTypes.vue?vue&type=template&id=61507f56"
import script from "./FactureTypes.vue?vue&type=script&lang=js"
export * from "./FactureTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports